"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TreeContext = void 0;
const react_1 = require("react");
exports.TreeContext = (0, react_1.createContext)({});
//# sourceMappingURL=tree-context.js.map